import { getCsrfValue } from "~/common/utils/ApiHelper";

import { resolveApiUrl } from "~/utils/url/urlResolver";

export function apiUpdateSavedConfigName(configCode: string, name: string, comment: string): Promise<boolean> {
  const apiUrl = resolveApiUrl(`/saved-configs/${configCode}`);

  return fetch(apiUrl, {
    body: JSON.stringify({
      name: name,
      comment: comment,
    }),
    cache: "no-cache",
    credentials: "same-origin",
    method: "PATCH",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  })
    .then((result) => {
      if (result.ok) {
        return true;
      } else {
        console.error(`Error sending linear update: ${result.status}`);
        return false;
      }
    })
    .catch((err) => {
      console.error(err);
      return false;
    });
}
